'use client';

export interface AnalyticsPrivacyState {
	status: 'pending' | 'resolved';
	analyticsAllowed: boolean;
	marketingAllowed: boolean;
	saleOfDataAllowed: boolean;
}

export const ANALYTICS_PRIVACY_STATE_EVENT = 'workman:analytics-privacy-state';

export let analyticsPrivacyState: AnalyticsPrivacyState = {
	status: 'pending',
	analyticsAllowed: false,
	marketingAllowed: false,
	saleOfDataAllowed: false,
};

export function getAnalyticsPrivacyState() {
	return analyticsPrivacyState;
}

export function setStoredAnalyticsPrivacyState(state: AnalyticsPrivacyState) {
	analyticsPrivacyState = state;

	if (typeof window === 'undefined') return;
	window.dispatchEvent(
		new CustomEvent<AnalyticsPrivacyState>(ANALYTICS_PRIVACY_STATE_EVENT, {
			detail: state,
		}),
	);
}

export function subscribeAnalyticsPrivacyState(listener: (state: AnalyticsPrivacyState) => void) {
	if (typeof window === 'undefined') return () => {};

	const handler = (event: Event) => {
		listener((event as CustomEvent<AnalyticsPrivacyState>).detail);
	};

	window.addEventListener(ANALYTICS_PRIVACY_STATE_EVENT, handler);
	return () => window.removeEventListener(ANALYTICS_PRIVACY_STATE_EVENT, handler);
}

export function canSendMarketingFromState(state = analyticsPrivacyState) {
	return (
		state.status === 'resolved' &&
		state.analyticsAllowed &&
		state.marketingAllowed &&
		state.saleOfDataAllowed
	);
}
